import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
export function ContenidoSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  const listItemVariants = {
    hidden: {
      opacity: 0,
      x: -10
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.4,
        ease: 'easeOut'
      }
    }
  };
  const items = ['Más de 260 actividades en PDF', 'Imprimibles y reutilizables', 'Temas: familia, animales, colores, emociones, números, vocales, alimentos, naturaleza, formas geométricas y más', 'Diseño infantil, atractivo y claro', 'Listo para usar desde casa o en el aula', 'Compatible con cualquier impresora'];
  return <section className="w-full bg-[#fff8e1] py-10 px-4 md:py-16 overflow-hidden" data-id="element-53">
      <motion.div className="max-w-md md:max-w-2xl mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      amount: 0.2
    }} data-id="element-54">
        <motion.h2 variants={itemVariants} className="text-[1.6rem] md:text-2xl font-black text-center text-[#0d47a1] mb-4" style={{
        textDecoration: 'underline',
        textDecorationColor: '#ffff00',
        textDecorationThickness: '4px',
        textUnderlineOffset: '4px'
      }} data-id="element-55">
          ¿QUÉ CONTIENE EL MATERIAL?
        </motion.h2>

        <motion.ul className="space-y-2 text-base leading-[1.6] text-gray-800 font-medium mb-6" variants={containerVariants} data-id="element-56">
          {items.map((item, index) => <motion.li key={index} variants={listItemVariants} data-id="element-57">
              ✔️ {item}
            </motion.li>)}
        </motion.ul>

        {/* GIFs side by side */}
        <motion.div variants={itemVariants} className="grid grid-cols-2 gap-4 mt-6" data-id="element-58">
          <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1770714265/IMG_2047-1_htwx3u.gif" alt="Portada libro estimulante para bebés" className="rounded-xl w-full h-auto object-cover" data-id="element-59" />
          <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1770714273/IMG_2046-1_xt4eng.gif" alt="Mamás usando las actividades" className="rounded-xl w-full h-auto object-cover" data-id="element-60" />
        </motion.div>
      </motion.div>
    </section>;
}